<div class="filter-container">
  <div class="filter-inner">
    <div class="title-header" [innerHTML]="'CALENDAR.FILTER.TITLE' | translate"></div>
    <div class="filter-form-container">
      <form [formGroup]="filterForm">
        <div class="row filter-form-container-inner">
          <div class="filter col-12 col-md-4 row">
            <eps-select label="CALENDAR.FILTER.DEPOT" labelPosition="top" [options]="depots" formControlName="depots" hideOptionalMarker [showErrors]="false" multiple [labelsDisplayed]="1"></eps-select>
          </div>
          <div class="filter col-12 col-md-4 row">
            <eps-label-body label="ORDERS.FILTER.LABELS.ORDER_TYPE" labelPosition="top" hideOptionalMarker>
              <div class="checkboxes">
                <eps-checkbox labelPosition="none" checkboxLabel="CALENDAR.FILTER.DELIVERY" formControlName="orderTypeDelivery" [showErrors]="false"></eps-checkbox>
                <eps-checkbox labelPosition="none" checkboxLabel="CALENDAR.FILTER.RETURN" formControlName="orderTypeReturn" [showErrors]="false"></eps-checkbox>
                <eps-checkbox labelPosition="none" checkboxLabel="CALENDAR.FILTER.DIRECT" formControlName="orderTypeDirect" [showErrors]="false"></eps-checkbox>
              </div>
            </eps-label-body>
          </div>
          <div class="filter col-12 col-md-4 row">
            <eps-label-body label="ORDERS.FILTER.LABELS.TRANSPORT" labelPosition="top" hideOptionalMarker>
              <div class="checkboxes">
              <eps-checkbox labelPosition="none" checkboxLabel="CALENDAR.FILTER.OWN" formControlName="transportPickup" [showErrors]="false"></eps-checkbox>
              <eps-checkbox labelPosition="none" checkboxLabel="CALENDAR.FILTER.BY_EPS" formControlName="transportEps" [showErrors]="false"></eps-checkbox>
              </div>
            </eps-label-body>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
